<template>
  <div class="customerList">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <div class="total_con">
      <el-form :inline="true">
        <el-form-item label="交易总手數:"><p>{{ totalNum.totalExcVolume }}</p></el-form-item>
        <el-form-item label="交易返佣总金额:"><p>{{ totalNum.total }}</p></el-form-item>
        <el-form-item v-for="item in totalNum.level" :label="+item.name+'级代理返佣:'">
          <p>{{ item.num }}</p>
        </el-form-item>
      </el-form>
    </div>
    <table-page ref="childTable" :pageData="pageData"></table-page>
  </div>
</template>

<script>
import Url from '@/views/agent/util/url'
import DateUtil from '@/utils/dataUtil'
import FORM from '@/components/page/form'
import tablePage from '@/components/page/table'
import download from '@/utils/download'

let platformArr = { 'GTS2': 'GTS2', 'MT5': 'MT5' }
export default {
  name: 'rebateDetailList',
  components: {
    FORM,
    tablePage
  },
  data() {
    return {
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: '結算代理編碼', field: 'agentCode' },
          { title: '交易账号', field: 'customerNumber' },
          {
            title: '时间',
            field: 'time',
            type: 6,
            format: 'yyyy-MM-dd HH:mm:ss',
            startEndParam: ['startTime', 'endTime']
          },
          {
            title: '交易平台',
            field: 'platform',
            type: 2,
            optionList: platformArr,
            data: []
          },
          { click: '当天' },
          { click: '当周' },
          { click: '当月' },
          { click: '最近三个月' },
          { click: window.$t('common.search') },
          { click: window.$t('common.export'), auth: 'analyse:rebateDetailList:export' }
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: Url.adAgent.rebateDetailList,
        selection: false,
        sequence: false,
        method: 'get',
        cols: [
          { title: '结算代理编码', field: 'agentCode' },
          { title: '结算代理', field: 'agentName' },
          { title: '交易账号', field: 'customerNumber' },
          { title: '直属代理编码', field: 'directAgentCode' },
          // { title: '直属代理名称', field: 'directAgentName' },
          { title: '所属一级代理编码', field: 'topAgentCode' },
          // { title: '所属一级代理名称', field: 'topAgentName' },
          // { title: '代理级别', field: 'level' },
          // { title: '返利層級', field: 'relationType' },
          { title: '交易产品', field: 'symbol' },
          { title: '持仓号', field: 'position' },
          { title: '平仓手数', field: 'excVolume' },
          { title: '奖励金额', field: 'rebate' },
          { title: '交易平台', field: 'platform' },
          { title: '交易奖励方案', field: 'settingId' },
          {
            title: '平仓时间', field: 'excTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '返佣時間', field: 'ctime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          }
        ]
      },
      totalNum: {}
    }
  },
  methods: {
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    dateToString(data) {
      let date = data.replace(/-/g, '/') //必须把日期'-'转为'/'
      return new Date(date).getTime()
    },
    formatDate(data) {
      var yy = data.getFullYear()      //年
      var mm = data.getMonth() + 1     //月
      var dd = data.getDate()          //日
      var clock = yy + '-'
      if (mm < 10) clock += '0'
      clock += mm + '-'
      if (dd < 10) clock += '0'
      clock += dd + ' '
      return clock
    },
    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        data.startTime = data.startTime ? new Date(data.startTime).getTime() : ''
        data.endTime = data.endTime ? new Date(data.endTime).getTime() : ''
        this.queryData = data
        this.$refs.childTable.defaultGetData(data)
      } else if ('当天' == clickName) {
        let now = new Date()
        data.startTime = new Date(this.dateToString(this.formatDate(now) + ' 00:00:00')).getTime()
        data.endTime = now.getTime()
        this.$refs.childTable.defaultGetData(data)
      } else if ('当周' == clickName) {
        let now = new Date()
        let day = now.getDay()
        if (day == 0) {
          day = 7
        }
        now.setDate(now.getDate() - day + 1)
        data.startTime = new Date(this.dateToString(this.formatDate(now) + ' 00:00:00')).getTime()
        data.endTime = new Date().getTime()
        this.$refs.childTable.defaultGetData(data)
      } else if ('当月' == clickName) {
        let now = new Date()
        now.setDate(1)
        data.startTime = new Date(this.dateToString(this.formatDate(now) + ' 00:00:00')).getTime()
        data.endTime = new Date().getTime()
        this.$refs.childTable.defaultGetData(data)
      } else if ('最近三个月' == clickName) {
        let now = new Date()
        data.startTime = new Date(now.setMonth(now.getMonth() - 3)).getTime()
        data.endTime = new Date().getTime()
        this.$refs.childTable.defaultGetData(data)
      }
      if ('导出' == clickName || window.$t('common.export') == clickName) {
        data.startTime = data.startTime ? new Date(data.startTime).getTime() : ''
        data.endTime = data.endTime ? new Date(data.endTime).getTime() : ''
        download.exportExcel(Url.adAgent.rebateDetailDown, data, '代理返佣奖励明细')
      } else {
        this.getTotalNum(data)
      }
    },
    getTotalNum(option) {
      this.$axios.get(Url.adAgent.rebateDetailTotal, { params: option }).then(res => {
        if (res.code == 0) {
          this.totalNum = res.result
          this.totalNum.level = []
          for (const i in this.totalNum) {
            if (Number(i)) {
              this.totalNum.level.push({ name: i, num: this.totalNum[i] })
            }
          }
        }
      })
    }
  },
  mounted() {
    this.getTotalNum({})
  }
}
</script>

<style>
.customerList .total_con {
  width: 96%;
  margin: 0 auto;
}

.customerList .total_con .el-form-item {
  margin: 0 30px 0 0;
}

.customerList .total_con p {
  color: #ff5500;
  font-size: 16px;
  font-weight: bolder;
}
</style>
